import { JsonSchema, UISchemaElement } from '@jsonforms/core'
import { materialCells, materialRenderers } from '@jsonforms/material-renderers'
import { JsonForms } from '@jsonforms/react'
import { makeStyles } from '@material-ui/core'
import BugReportOutlined from '@material-ui/icons/BugReportOutlined'
import accordionGroupRenderers from 'customForm/formRenderers/accordionRenderer'
import AlertRenderer from 'customForm/formRenderers/alertRenderer'
import ArrayTabRenderer from 'customForm/formRenderers/arrayTabRenderer'
import AutocompleteSearchRenderer from 'customForm/formRenderers/autocompleteSearchRenderer/AutocompleteSearchRenderer'
import CategorizedList from 'customForm/formRenderers/categorizedList'
import ConditionBuilderRenderer from 'customForm/formRenderers/conditionBuilderRenderer'
import CustomFormRenderer from 'customForm/formRenderers/customFormRenderer'
import DatePickerRenderer from 'customForm/formRenderers/datepickerRenderer'
import expandableTermsRenderer from 'customForm/formRenderers/expandableTermsRenderer'
import ExpandableTypedListRenderer from 'customForm/formRenderers/expandableTypedListRenderer'
import HtmlEditorRenderer from 'customForm/formRenderers/htmlEditorRenderer'
import ImageRenderer from 'customForm/formRenderers/imageRenderer'
import ImageUploadRenderer from 'customForm/formRenderers/imageUploadRenderer'
import JsonEditorRenderer from 'customForm/formRenderers/jsonEditorRenderer'
import OSInputControlRenderer from 'customForm/formRenderers/osInputControlRenderer'
import ReduxButtonRenderer from 'customForm/formRenderers/reduxButton'
import TranslatableTextRenderer from 'customForm/formRenderers/translatableTextRenderer'
import TypographyRenderer from 'customForm/formRenderers/typographyRenderer'
import ZoomableImageRenderer from 'customForm/formRenderers/zoomableImageRenderer'
import { authSelectors } from 'ducks/auth'
import { ComponentVersions_2_1, ComponentVersionsInherit, IconButton, Menu, MenuItem } from 'opensolar-ui'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  debugContainer: { position: 'relative' },
  formContainer: { width: '100%' },
  codeBlock: { width: '100%' },
  devButton: { position: 'absolute', top: -20, right: 0 },
}))
export interface JsonFormsDebuggableProps {
  header?: string
  header_subtext?: string
  schema: JsonSchema
  uischema?: UISchemaElement
  data: any
  onChange(newData: any, errors: any): void
  config?: {
    integration?: string
    [key: string]: any
  }
  readonly?: boolean
}

export const JsonFormsDebuggable = (props: JsonFormsDebuggableProps) => {
  const isStaff = useSelector(authSelectors.getIsStaff)
  const classes = useStyles()

  const [showTab, setShowTab] = useState(0)
  const [open, setOpen] = useState(false)
  const [devButton, setDevButton] = useState<HTMLElement | null>(null)

  const selectTab = useCallback((index) => {
    setShowTab(index)
    setOpen(false)
  }, [])

  return (
    <>
      {isStaff && (
        <div className={classes.debugContainer}>
          <>
            <div className={classes.devButton}>
              <IconButton onClick={() => setOpen(!open)} ref={(el) => setDevButton(el)} size="small">
                <BugReportOutlined />
              </IconButton>
              <Menu
                id="basic-menu"
                open={open}
                onClose={() => setOpen(false)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                anchorEl={devButton}
              >
                <MenuItem disabled={true}>Staff Only</MenuItem>
                <MenuItem onClick={() => selectTab(0)}>Form</MenuItem>
                <MenuItem onClick={() => selectTab(1)}>Schema</MenuItem>
                <MenuItem onClick={() => selectTab(2)}>UI Schema</MenuItem>
                <MenuItem onClick={() => selectTab(3)}>Data</MenuItem>
              </Menu>
            </div>
          </>
        </div>
      )}
      {showTab === 0 && (
        <ComponentVersionsInherit versions={ComponentVersions_2_1}>
          <div className={classes.formContainer}>
            <JsonForms
              schema={props.schema}
              uischema={props.uischema}
              data={props.data}
              config={props.config}
              //   ajv={ajv}
              readonly={props.readonly}
              renderers={
                [
                  OSInputControlRenderer,
                  ...accordionGroupRenderers,
                  ...materialRenderers,
                  CategorizedList,
                  ImageRenderer,
                  ImageUploadRenderer,
                  ZoomableImageRenderer,
                  ConditionBuilderRenderer,
                  TranslatableTextRenderer,
                  HtmlEditorRenderer,
                  AlertRenderer,
                  ArrayTabRenderer,
                  ReduxButtonRenderer,
                  CustomFormRenderer,
                  expandableTermsRenderer,
                  DatePickerRenderer,
                  ExpandableTypedListRenderer,
                  JsonEditorRenderer,
                  TypographyRenderer,
                  AutocompleteSearchRenderer,
                ] as any
              }
              cells={materialCells}
              onChange={(state) => props.onChange(state.data, state.errors)}
            />
          </div>
        </ComponentVersionsInherit>
      )}
      {showTab === 1 && (
        <div className={classes.codeBlock + ' code-block'}>{JSON.stringify(props.schema, null, '\t')}</div>
      )}
      {showTab === 2 && (
        <div className={classes.codeBlock + ' code-block'}>{JSON.stringify(props.uischema, null, '\t')}</div>
      )}
      {showTab === 3 && (
        <div className={classes.codeBlock + ' code-block'}>{JSON.stringify(props.data, null, '\t')}</div>
      )}
    </>
  )
}
